// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:54:41.370Z
// Property: Stoneridge (ID: 6767906449166910)
// Collections: 38 amenities, 5 floorplans (live), 57 photos, 37 POIs, 3 reviews, 6 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166910",
  "property_external_id": "495837",
  "property_zillow_url": "https://www.zillow.com/homedetails/2801-Alexandra-Dr-Roseville-CA-95661/188166909_zpid/",
  "property_apartments_url": "https://www.apartments.com/stoneridge-roseville-ca/qjdby5z/",
  "property_google_business_url": "https://www.google.com/maps/place/Stoneridge+Apartments/data=!4m2!3m1!1s0x0:0x6e28bb2f206a1a44?sa=X&ved=2ahUKEwip8Oe4mrySAxW5RTABHQ1yDA8Q_BJ6BAgZEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "56463148338",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495837 p0505505",
  "property_status": null,
  "property_slug": "stoneridge",
  "property_name": "Stoneridge",
  "property_website_url": "www.roseville-california-apartments.net",
  "property_domain": "https://www.roseville-california-apartments.net/",
  "property_address": "2801 Alexandra Drive",
  "property_full_address": "2801 Alexandra Drive, Roseville, CA, 95661",
  "property_address_1": "2801 Alexandra Drive",
  "property_address_2": null,
  "property_address_city": "Roseville",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95661",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "East Roseville Parkway",
  "property_address_latitude": "38.7618",
  "property_address_longitude": "-121.2312",
  "property_email": "stoneridge@ctlmanagement.com",
  "property_phone": "(833) 384-1020",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Stoneridge Apartments in Roseville, CA, your perfect home awaits! Choose from one, two, or three-bedroom floor plans thoughtfully designed with modern amenities. Enjoy a refreshing dip in the pool, stay fit in our fitness center, and unwind in the serene picnic area. Embrace a lifestyle of comfort and convenience today!",
  "property_long_description": "**Discover Your Ideal Home at Stoneridge Apartments in Roseville, CA**\n\nWelcome to Stoneridge Apartments, where comfort meets convenience in a vibrant community setting! Nestled in the heart of Roseville, our thoughtfully designed floor plans feature one, two, and three-bedroom options, ensuring the perfect fit for individuals, couples, and families alike. \n\nAt Stoneridge, we prioritize your lifestyle with an array of exceptional amenities. Dive into relaxation at our sparkling pool, or break a sweat in our fully equipped fitness center. Families will love the on-site playground, while social butterflies can unwind in our welcoming clubhouse or gather in the picnic area complete with grills for delightful summer barbecues. \n\nYour safety and comfort are paramount; enjoy the peace of mind that comes with controlled access, a dedicated property manager on-site, and a gated community. Stay connected with high-speed internet access and online services, making remote work and everyday life seamless. \n\nOur spacious apartments come loaded with modern features, including granite countertops, stainless steel appliances, and designer finishes. With amenities like a washer/dryer in every unit, walk-in closets, and private balconies or patios, you’ll love the luxurious details that make Stoneridge feel like home. \n\nPlus, outdoor enthusiasts will appreciate the nearby walking and biking trails that enhance your daily routine. \n\nDon't miss your chance to elevate your living experience at Stoneridge Apartments. Find your new home today—browse our availability or schedule a tour to visit our beautiful community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019db191-e17a-73f1-9576-1f38d02b3ae1.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and seating areas.",
    "public_id": "019db191-e17a-73f1-9576-1f38d02b3ae1",
    "storage_key": "property/6767906449166910/019db191-e17a-73f1-9576-1f38d02b3ae1.webp",
    "width": 1800,
    "height": 911
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "230",
  "property_year_built": "2004",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.21739130434783",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://roseville-california-apartments.securecafe.com/onlineleasing/stoneridge-3/floorplans.aspx",
  "property_resident_portal_url": "https://roseville-california-apartments.securecafe.com/residentservices/stoneridge-3/userlogin.aspx",
  "property_apply_now_url": "https://roseville-california-apartments.securecafe.com/onlineleasing/stoneridge-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d740f-dd16-70da-a531-65e8227b9ca9.webp",
  "property_primary_logo_media": {
    "alt_text": "The Stoneridge Apartments logo.",
    "public_id": "019d740f-dd16-70da-a531-65e8227b9ca9",
    "storage_key": "property/6767906449166910/019d740f-dd16-70da-a531-65e8227b9ca9.webp",
    "width": 532,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d740f-dcff-76b0-8008-f238669fe1fe.webp",
  "property_secondary_logo_media": {
    "alt_text": "Stoneridge Apartments logo",
    "public_id": "019d740f-dcff-76b0-8008-f238669fe1fe",
    "storage_key": "property/6767906449166910/019d740f-dcff-76b0-8008-f238669fe1fe.webp",
    "width": 528,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019de0b2-53a1-7488-94ef-d537ac62b468.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stoneridge Apartments logo",
    "public_id": "019de0b2-53a1-7488-94ef-d537ac62b468",
    "storage_key": "property/6767906449166910/019de0b2-53a1-7488-94ef-d537ac62b468.webp",
    "width": 532,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019de0b2-475b-74d2-bd03-fc4cb0f0771a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Stoneridge Apartments logo.",
    "public_id": "019de0b2-475b-74d2-bd03-fc4cb0f0771a",
    "storage_key": "property/6767906449166910/019de0b2-475b-74d2-bd03-fc4cb0f0771a.webp",
    "width": 532,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "750 - 1077",
  "property_sqft_min": "750",
  "property_sqft_max": "1077",
  "property_price_range": "1965 - 2995",
  "property_price_min": "1965",
  "property_price_max": "2995",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/StoneridgeRosevilleApartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJF6Kldrkfm4ARRBpqIC-7KG4",
  "property_youtube_url": "https://www.youtube.com/watch?v=PEKOpeRkhVs",
  "property_yelp_url": "https://www.yelp.com/biz/silver-ridge-senior-apartments-roseville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stoneridge Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Stoneridge Apartments in Roseville, CA, where comfort meets convenience. Choose from spacious one, two, or three-bedroom layouts featuring sleek granite countertops and high-speed internet. Dive into our refreshing pool, unwind at the clubhouse, or stroll along scenic walking trails. Your ideal living experience awaits!",
  "property_home_floorplans_blurb": "Welcome to Stoneridge Apartments in the heart of Roseville, CA, where comfort meets style. Our thoughtfully designed floor plans cater to your lifestyle, blending modern amenities with a welcoming atmosphere. Browse available apartment homes today and uncover your ideal living space that suits your unique needs and aspirations.",
  "property_home_gallery_blurb": "At Stoneridge Apartments in Roseville, CA, choose from one-, two-, or three-bedroom floor plans that blend luxury with comfort. Soak up the sun by the pool, work out at the fitness center, or unwind on your private patio. Picture yourself living here, where modern amenities meet a vibrant community!",
  "property_home_neighborhood_blurb": "Welcome to Stoneridge Apartments in vibrant Roseville, CA! Our diverse floor plans cater to every lifestyle, whether you're seeking a cozy one-bedroom or a spacious three-bedroom home. Enjoy the perfect blend of comfort and convenience, with nearby attractions like the Sierra College Natural History Museum, Maidu Park, and thrilling adventures at Roseville Golfland Sunsplash—all just steps away!",
  "property_home_reviews_blurb": "At Stoneridge Apartments in Roseville, CA, our residents rave about the vibrant community atmosphere, calling it \"a hidden gem with friendly neighbors and fantastic amenities.\" It’s not just a place to live; it's a place to thrive. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Stoneridge Apartments in Roseville, CA, life's best moments are just outside your door. Relish the outdoors at Maidu Regional Park or uncover local history at the Sierra College Natural History Museum. With top-notch schools and vibrant parks nearby, this community offers the perfect blend of comfort and convenience. Proceed to uncover your next adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Stoneridge Apartments in Roseville, CA, elevate your lifestyle with premium amenities designed for comfort and convenience. Dive into our sparkling pool, unwind at the spa, or get active at the fitness center. With spacious one, two, and three-bedroom layouts, modern features await—come see your new home today!",
  "property_applynow_blurb": "At Stoneridge Apartments in Roseville, CA, your ideal home awaits. Choose from one, two, or three-bedroom floor plans adorned with modern amenities like stainless steel appliances, walk-in closets, and a serene balcony. Enjoy a vibrant community featuring a pool, fitness center, and picturesque walking trails. Lease your new sanctuary today!",
  "property_contactus_blurb": "At Stoneridge Apartments in Roseville, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans, tailored to fit your lifestyle. Each space is a canvas for your personal touch. Have questions? Our friendly leasing team is ready to assist you—reach out today and start your journey home!",
  "property_faqs_blurb": "At Stoneridge Apartments in Roseville, CA, we understand that every resident's needs are unique. With thoughtfully designed one, two, and three-bedroom layouts, our community effortlessly blends comfort and style. For answers to your most pressing questions, browse our FAQs page and discover what makes Stoneridge the perfect home for you!",
  "property_floorplans_blurb": "At Stoneridge Apartments in Roseville, CA, spacious and inviting floor plans await you. Choose from one, two, or three-bedroom layouts designed for comfort and style. Each apartment offers a unique atmosphere perfect for relaxing or entertaining. Browse our available homes and uncover the ideal space tailored to your lifestyle!",
  "property_gallery_blurb": "At Stoneridge Apartments in Roseville, CA, life thrives amid stunning amenities and expansive floor plans. Whether you seek a cozy one-bedroom or a spacious three-bedroom, our community offers the perfect setting. From refreshing pool days to peaceful walks along scenic trails, picture yourself living here, where comfort meets convenience.",
  "property_interactivemap_blurb": "Welcome to Stoneridge Apartments in Roseville, CA, where comfort meets convenience. Choose from our spacious one, two, or three-bedroom floor plans, all featuring modern amenities like a shimmering pool, a state-of-the-art fitness center, and serene walking trails. Check out our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Stoneridge Apartments in Roseville, CA, your furry companions are cherished! With a pet-friendly policy that welcomes indoor adult cats and dogs (up to 25 lbs), our community is perfect for animal lovers. Enjoy peaceful living alongside your pets while exploring our vibrant neighborhood and its amenities.",
  "property_referafriend_blurb": "At Stoneridge Apartments in Roseville, CA, our vibrant community is enhanced by spacious one, two, and three-bedroom floor plans. Whether seeking solitude or camaraderie, you’ll feel right at home. Great friends make great neighbors—refer a friend today and share the comfort of Stoneridge living together!",
  "property_residentaccess_blurb": "Welcome to Stoneridge Apartments in Roseville, CA, where comfort meets convenience. With thoughtfully designed one, two, and three-bedroom floor plans tailored to suit your lifestyle, everything you need is just a click away. Access your resident portal now to pay rent, schedule maintenance, and enjoy effortless living!",
  "property_reviews_blurb": "At Stoneridge Apartments in Roseville, CA, residents rave about the “friendly community atmosphere” and spacious layouts. With stunning amenities and a prime location, it’s no wonder they feel right at home. See what our residents have to say about living at our community and find your perfect place today!",
  "property_created_at": "1762785174258",
  "property_scheduletour_blurb": "At Stoneridge Apartments in Roseville, CA, we offer a variety of spacious floor plans, including one, two, and three-bedroom layouts designed for your comfort. Schedule a tour today and see why our vibrant community is the perfect place to call home—check out resident testimonials to hear their stories!",
  "property_thankyou_blurb": "Thank you for reaching out to Stoneridge Apartments in beautiful Roseville, CA! We offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options to suit your lifestyle. Our team will be in touch soon to help you find your perfect home. Stay tuned!",
  "property_virtualtours_blurb": "Welcome to Stoneridge Apartments in beautiful Roseville, CA, where your ideal home awaits. Choose from chic one, two, or three-bedroom floor plans that cater to every lifestyle. Immerse yourself in our inviting atmosphere—click to take a virtual tour and step into your dream apartment today!",
  "property_copyright": "2025 All Rights Reserved. Stoneridge Apartments",
  "property_seo_title_home": "Stoneridge Apartments |  Apartments in Roseville, CA",
  "property_seo_description_home": "Discover life at Stoneridge Apartments in Roseville, CA, with spacious layouts, great amenities, a refreshing pool, and scenic trails. Welcome home!",
  "property_seo_title_floorplans": "Floor Plans | Roseville, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Stoneridge Apartments in Roseville, CA! Choose from stylish one to three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Roseville, CA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Stoneridge Apartments in Roseville, CA. Enjoy luxurious amenities like a pool, fitness center, and stunning floor plans. Experience comfort today!",
  "property_seo_title_gallery": "Gallery | Apartments in Roseville, CA",
  "property_seo_description_gallery": "Discover Stoneridge Apartments in Roseville, CA: modern amenities, spacious homes, a sparkling pool, and a vibrant community await!",
  "property_seo_title_virtualtours": "Virtual Tours | Stoneridge Apartments Apartments",
  "property_seo_description_virtualtours": "Discover Stoneridge Apartments in Roseville, CA! Explore spacious 1-3 bedroom homes with our virtual tour. Your new lifestyle awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Stoneridge Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Stoneridge Apartments in Roseville, CA. Navigate our interactive map to explore available one, two, and three-bedroom options today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Roseville, CA",
  "property_seo_description_neighborhood": "Discover Roseville’s hidden gems near Stoneridge Apartments! Enjoy parks and dining just steps from your new one, two, or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | Stoneridge Apartments",
  "property_seo_description_contact": "Reach out to Stoneridge Apartments in Roseville, CA! Whether you're eyeing a cozy one-bedroom or a spacious three-bedroom, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Roseville, CA",
  "property_seo_description_faqs": "Find essential answers about Stoneridge Apartments in Roseville, CA. From floor plans to amenities, our FAQs will guide your journey to a perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Roseville, CA",
  "property_seo_description_reviews": "Discover why Stoneridge Apartments in Roseville, CA feels like home! Read resident reviews and find your perfect space today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Roseville, CA",
  "property_seo_description_applynow": "Discover your dream home at Stoneridge Apartments in Roseville! Enjoy luxury amenities, spacious layouts, and a friendly community. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Stoneridge Apartments",
  "property_seo_description_residentaccess": "Experience seamless living at Stoneridge Apartments in Roseville! Log in to your resident portal for rent payment, maintenance requests, and more, anytime!",
  "property_seo_title_referafriend": "Refer A Friend | Stoneridge Apartments",
  "property_seo_description_referafriend": "Refer a friend to Stoneridge Apartments in Roseville, CA! Great friends make great neighbors—share the joy of upscale living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Stoneridge Apartments",
  "property_seo_description_scheduletour": "Experience life at Stoneridge Apartments in Roseville, CA. Schedule your tour today and discover your perfect home in a vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Stoneridge Apartments",
  "property_seo_description_privacy": "At Stoneridge Apartments in Roseville, CA, we prioritize your privacy. Learn how we safeguard your personal information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Stoneridge Apartments",
  "property_seo_description_accessibility": "Discover inclusive living at Stoneridge Apartments in Roseville, CA, where accessibility makes everyone feel at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Stoneridge Apartments",
  "property_seo_description_sitemap": "Unravel the charm of Stoneridge Apartments in Roseville, CA. Navigate our sitemap for a seamless journey through your future home and community.",
  "property_seo_title_thankyou": "Thank You | Stoneridge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Stoneridge Apartments in Roseville, CA! Expect a prompt response from our team to help you find your dream home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Roseville, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1784271971154",
  "amenities": [
    {
      "id": "ec_c5b0f04e5fcccbd19ac5da3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429514",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-69a5-715b-9470-0ae61a1d25b3.webp",
      "amenity_image_media": {
        "alt_text": "Lobby seating area with plush chairs, a glass coffee table, and large windows overlooking the pool and courtyard.",
        "public_id": "019d1c0c-69a5-715b-9470-0ae61a1d25b3",
        "storage_key": "property/6767906449166910/019d1c0c-69a5-715b-9470-0ae61a1d25b3.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Clubroom at Stoneridge, Roseville",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0b891faba9dc9e7e187363f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429515",
      "title": "Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4751f1982bde5131903e4e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429512",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-6fd4-7598-86e4-95ae10f8f2f9.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and seating.",
        "public_id": "019eb54d-6fd4-7598-86e4-95ae10f8f2f9",
        "storage_key": "property/6767906449166910/019eb54d-6fd4-7598-86e4-95ae10f8f2f9.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A room with a brown leather table and blue chairs at Stoneridge Apartments, California, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96abf0a2debca73392e6225e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429509",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-72ad-7351-aac3-a3cc013f584d.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with weight machines, benches, and dumbbells.",
        "public_id": "019eb54d-72ad-7351-aac3-a3cc013f584d",
        "storage_key": "property/6767906449166910/019eb54d-72ad-7351-aac3-a3cc013f584d.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A gym with a variety of equipment including a leg press machine at Stoneridge Apartments, California, 95661,A gym with a variety of equipment including a squat rack, a bench, and a barbell at Stoneridge Apartments, California, 95661,A gym with exercise equipment and fitness balls at Stoneridge Apartments, California, 95661,A gym with treadmills, elliptical machines, and exercise balls.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0709c49206edca2fe268305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429519",
      "title": "Lap-Size Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c14-2923-72f3-b673-0021c14e1f67.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background",
        "public_id": "019d1c14-2923-72f3-b673-0021c14e1f67",
        "storage_key": "property/6767906449166910/019d1c14-2923-72f3-b673-0021c14e1f67.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Resort Style Pool at Stoneridge, Roseville, California,Sparkling Pool at Stoneridge, Roseville, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a79e4fb0f6a058078beb2ea0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429524",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c14-298c-77f8-a52e-3f28db129779.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
        "public_id": "019d1c14-298c-77f8-a52e-3f28db129779",
        "storage_key": "property/6767906449166910/019d1c14-298c-77f8-a52e-3f28db129779.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Spa And Pool at Stoneridge, Roseville",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e03df06af815eb04d2bf9327",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429521",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-e2a9-77bf-b715-031cb2c64e08.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building exterior with a picnic area and barbecue grills in the foreground.",
        "public_id": "019d334a-e2a9-77bf-b715-031cb2c64e08",
        "storage_key": "property/6767906449166910/019d334a-e2a9-77bf-b715-031cb2c64e08.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Picnic BBQ at Stoneridge, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3936f829ab6dd62e26bbc22d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429522",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d291e-24b0-70bc-b3f1-26f41659f99c.webp",
      "amenity_image_media": {
        "alt_text": "Playground with swings and slides, surrounded by a black fence and trees.",
        "public_id": "019d291e-24b0-70bc-b3f1-26f41659f99c",
        "storage_key": "property/6767906449166910/019d291e-24b0-70bc-b3f1-26f41659f99c.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Playground at Stoneridge, Roseville, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b43ba637fb2783fd1ac2848d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429513",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8dc4-76cc-be6d-a17797e6d0f7.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment building with parking lot and covered parking spaces.",
        "public_id": "019d2e3c-8dc4-76cc-be6d-a17797e6d0f7",
        "storage_key": "property/6767906449166910/019d2e3c-8dc4-76cc-be6d-a17797e6d0f7.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Carports at Stoneridge, Roseville, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e05fe8854517fbd269967378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311327",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8d03-768a-ae14-f28cf237adc3.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub parcel lockers for resident package delivery.",
        "public_id": "019d2e3c-8d03-768a-ae14-f28cf237adc3",
        "storage_key": "property/6767906449166910/019d2e3c-8d03-768a-ae14-f28cf237adc3.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Self Serve Package Lockers at Stoneridge, California, 95661,Package Lockers at Stoneridge, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21f268f12cc8d7cf66c70040",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "86463000",
      "title": "Close By Recreational Parks & Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13b3128092923b4231985ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429516",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb5f43cb97ef9b4ef48c5e9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429520",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a01a300f587359723e1da0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429540",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_838685e1366d566b89cb9258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "82390282",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abd044996f1cbebb93dc98cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "82390284",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dea660d6e43ddce246ca2a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "86463002",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88ad72460504fc056761cfbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429534",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de6f-70ed-be27-e0ae7ca6b3df.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with granite countertop, toilet, and laundry area with washer and dryer.",
        "public_id": "019d334a-de6f-70ed-be27-e0ae7ca6b3df",
        "storage_key": "property/6767906449166910/019d334a-de6f-70ed-be27-e0ae7ca6b3df.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Bathroom With Laundry Area at Stoneridge, Roseville, CA,Stacked Washer Dryer at Stoneridge, California, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03b3f0b31a5c57840719d9b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429542",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de03-71f8-8e4a-d84ee765a542.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with two clothes rods and beige walls.",
        "public_id": "019d334a-de03-71f8-8e4a-d84ee765a542",
        "storage_key": "property/6767906449166910/019d334a-de03-71f8-8e4a-d84ee765a542.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Spacious Closet View at Stoneridge, Roseville, California,Walk In Closet at Stoneridge, Roseville, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_928c8a5066c625e131016e08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429539",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-830d-764d-ae44-d132d3b7ddca.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with two chairs and view of community",
        "public_id": "019d3862-830d-764d-ae44-d132d3b7ddca",
        "storage_key": "property/6767906449166910/019d3862-830d-764d-ae44-d132d3b7ddca.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Large Balcony And Patio at Stoneridge, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ea8c7d135a067361a27278a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429530",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_010eb7f1ff1443fac4fba126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429529",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8ef0-749a-a751-f1bcbea97751.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area with a round table and chairs, microwave, and granite countertops.",
        "public_id": "019d2e3c-8ef0-749a-a751-f1bcbea97751",
        "storage_key": "property/6767906449166910/019d2e3c-8ef0-749a-a751-f1bcbea97751.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Kitchen With Dining Area at Stoneridge, California, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_495c51982996b02517bcf91e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429523",
      "title": "Scenic View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a18468a97b4a79b3ea3ddf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429537",
      "title": "Built-In Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d3852-4973-73a9-9b0e-194dacaa1a53",
        "storage_key": "property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Modern Kitchen at Stoneridge, Roseville",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e69ce6dfd0c9bf1f2026457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429527",
      "title": "Vinyl Plank Flooring - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de00f267438ee275653b328e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429526",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa5fa3a826a2d153e5030700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429531",
      "title": "Custom Maple Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
      "amenity_image_media": {
        "alt_text": "A modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d3852-48b7-7619-9182-2e8749270a18",
        "storage_key": "property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Fully Equipped Kitchen at Stoneridge, Roseville, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cda0011cbeb2cdd438c0634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429536",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48af-778b-9357-a768c983a6be.webp",
      "amenity_image_media": {
        "alt_text": "Updated bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019d3852-48af-778b-9357-a768c983a6be",
        "storage_key": "property/6767906449166910/019d3852-48af-778b-9357-a768c983a6be.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Bathroom With Vanity Lights at Stoneridge, Roseville, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_061b546b28a0841362f0d44b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311333",
      "title": "Curved Shower Rod - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4cfb-7448-bb7e-026bf3ecbb21.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with bathtub, shower, and vanity.",
        "public_id": "019d3852-4cfb-7448-bb7e-026bf3ecbb21",
        "storage_key": "property/6767906449166910/019d3852-4cfb-7448-bb7e-026bf3ecbb21.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Modern Bathroom at Stoneridge, Roseville, California,Model Bathroom at Stoneridge, Roseville, 95661",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e556d2fc51f61b7749c6340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80665162",
      "title": "Tile Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f13396d4551775e5af6de4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311334",
      "title": "Attached 1 or 2 Car Garage - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8ef7-72a9-b547-57dfb59754c8.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building exterior with garages and balconies.",
        "public_id": "019d2e3c-8ef7-72a9-b547-57dfb59754c8",
        "storage_key": "property/6767906449166910/019d2e3c-8ef7-72a9-b547-57dfb59754c8.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Garages at Stoneridge, Roseville, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5708bee09a299251d6cb7d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311340",
      "title": "Kitchen Pantry - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, microwave, stove, and double sink.",
        "public_id": "019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d",
        "storage_key": "property/6767906449166910/019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "kitchen and pantry at Stoneridge, Roseville, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fba5658e904042aa1a001d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311341",
      "title": "Stainless Steel Appliances - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d3852-4973-73a9-9b0e-194dacaa1a53",
        "storage_key": "property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Granite Countertop at Stoneridge, Roseville",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ab1db23e375161c50b8caed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311342",
      "title": "Granite Counter Tops - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
      "amenity_image_media": {
        "alt_text": "A modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d3852-48b7-7619-9182-2e8749270a18",
        "storage_key": "property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Kitchen Countertop at Stoneridge, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd42494b4555a51e12de17ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "87311543",
      "title": "Attached Storage - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee97ee7eb1f4e38dcec6b267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429535",
      "title": "Gas Fireplace - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77f4db4b34cbe4a1e7469dd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80429528",
      "title": "Built-In Computer Station In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e92a2d4911cc597a1a0c5795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "yardi",
      "external_id": "80665163",
      "title": "Dual Primary Suites In Select Floor Plans *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_217190bdd950daff8de8e54d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-69a0-773d-9c55-1f2dc0b8678c.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
        "public_id": "019d1c0c-69a0-773d-9c55-1f2dc0b8678c",
        "storage_key": "property/6767906449166910/019d1c0c-69a0-773d-9c55-1f2dc0b8678c.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring stainless steel appliances, including a refrigerator, microwave, and oven, complemented by granite countertops and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantKitchen01.jpg"
    },
    {
      "id": "ec_70bac6d481a49a2e35fc7794",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-6879-7059-8155-c2c915d66812.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, stainless steel appliances, and a doorway.",
        "public_id": "019d1c0c-6879-7059-8155-c2c915d66812",
        "storage_key": "property/6767906449166910/019d1c0c-6879-7059-8155-c2c915d66812.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Enjoy a functional and stylish kitchen featuring light wood cabinetry, elegant granite countertops, and modern stainless steel appliances. This space offers ample storage and a convenient layout.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, stainless steel appliances, and a doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantKitchen02.jpg"
    },
    {
      "id": "ec_0aa7948fbb83f3fa80a054a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-6813-74e8-b5c1-c069a54c01e3.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d1c0c-6813-74e8-b5c1-c069a54c01e3",
        "storage_key": "property/6767906449166910/019d1c0c-6813-74e8-b5c1-c069a54c01e3.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring light wood cabinetry, granite countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantDiningRoom02.jpg"
    },
    {
      "id": "ec_4bc3d1b515e31891ec86c006",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-6816-76f8-9e81-a875c086ae96.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d1c0c-6816-76f8-9e81-a875c086ae96",
        "storage_key": "property/6767906449166910/019d1c0c-6816-76f8-9e81-a875c086ae96.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring light wood cabinets, granite countertops, stainless steel appliances, and ample natural light.",
      "link": "false",
      "alt_text": "Living room and kitchen area with light wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantDiningRoom01.jpg"
    },
    {
      "id": "ec_241b496956c1cb9146c254ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-6947-7668-9609-719f0ece3dae.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d1c0c-6947-7668-9609-719f0ece3dae",
        "storage_key": "property/6767906449166910/019d1c0c-6947-7668-9609-719f0ece3dae.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "A spacious and well-lit kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantHallway.jpg"
    },
    {
      "id": "ec_09f0f77f00a5d510ebb01325",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-681b-757e-af81-f123041f5b52.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo",
        "public_id": "019d1c0c-681b-757e-af81-f123041f5b52",
        "storage_key": "property/6767906449166910/019d1c0c-681b-757e-af81-f123041f5b52.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a single vanity with granite countertop, toilet, and a bathtub/shower combination.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_VacantBathroom01.jpg"
    },
    {
      "id": "ec_9271e1519c2c26c2c39e36b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-6ccb-71ef-9a2a-a6305cc6f11f.webp",
      "image_media": {
        "alt_text": "Stone Ridge Apartment Homes entrance sign",
        "public_id": "019d1c0c-6ccb-71ef-9a2a-a6305cc6f11f",
        "storage_key": "property/6767906449166910/019d1c0c-6ccb-71ef-9a2a-a6305cc6f11f.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Stone Ridge Apartment Homes, featuring a beautiful stone monument sign at the entrance to the property.",
      "link": "false",
      "alt_text": "Stone Ridge Apartment Homes entrance sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Monument.jpg"
    },
    {
      "id": "ec_951452adaa93292e141d82a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-8c67-7398-b2ea-783ac33f98dd.webp",
      "image_media": {
        "alt_text": "Exterior view of the leasing office building with manicured landscaping and parking spaces.",
        "public_id": "019eb54d-8c67-7398-b2ea-783ac33f98dd",
        "storage_key": "property/6767906449166910/019eb54d-8c67-7398-b2ea-783ac33f98dd.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to our leasing office, a central hub for resident services and information, set within a beautifully landscaped community.",
      "link": "false",
      "alt_text": "Exterior view of the leasing office building with manicured landscaping and parking spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_ClubhouseEntry(1).jpg"
    },
    {
      "id": "ec_41b7a1ef2b7cf2e1d70d649b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-86fe-736a-be75-ab2e114144b8.webp",
      "image_media": {
        "alt_text": "Exterior of leasing office at 3801 with monument sign and landscaping.",
        "public_id": "019eb54d-86fe-736a-be75-ab2e114144b8",
        "storage_key": "property/6767906449166910/019eb54d-86fe-736a-be75-ab2e114144b8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to the leasing office at 3801. Stop by to learn more about our community amenities and available floor plans.",
      "link": "false",
      "alt_text": "Exterior of leasing office at 3801 with monument sign and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_ClubhouseExterior.jpg"
    },
    {
      "id": "ec_a4ebbb564af1ee7dcf5e3764",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c0c-69a5-715b-9470-0ae61a1d25b3.webp",
      "image_media": {
        "alt_text": "Lobby seating area with plush chairs, a glass coffee table, and large windows overlooking the pool and courtyard.",
        "public_id": "019d1c0c-69a5-715b-9470-0ae61a1d25b3",
        "storage_key": "property/6767906449166910/019d1c0c-69a5-715b-9470-0ae61a1d25b3.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby seating area, featuring comfortable chairs and a modern coffee table. Large windows offer views of the resort-style pool and lush courtyard.",
      "link": "false",
      "alt_text": "Lobby seating area with plush chairs, a glass coffee table, and large windows overlooking the pool and courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_ClubhouseInterior02.jpg"
    },
    {
      "id": "ec_48b0d3b886a87f5dd088a3ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-6fd4-7598-86e4-95ae10f8f2f9.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating.",
        "public_id": "019eb54d-6fd4-7598-86e4-95ae10f8f2f9",
        "storage_key": "property/6767906449166910/019eb54d-6fd4-7598-86e4-95ae10f8f2f9.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Work and relax in our convenient business center, equipped with computers and comfortable seating areas.",
      "link": "false",
      "alt_text": "Business center with computers and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BusinessCenter(1).jpg"
    },
    {
      "id": "ec_1372f9843687304fcf965050",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-844e-750b-a651-91411eef0768.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and exercise balls.",
        "public_id": "019eb54d-844e-750b-a651-91411eef0768",
        "storage_key": "property/6767906449166910/019eb54d-844e-750b-a651-91411eef0768.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and a variety of exercise balls.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_FitnessCenterTreadmills.jpg"
    },
    {
      "id": "ec_38388b2a26c95eb66a06f058",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-8403-7279-9e9b-8bfc93d5ace3.webp",
      "image_media": {
        "alt_text": "Fitness center with elliptical machines, stability balls, resistance bands, and a yoga mat.",
        "public_id": "019eb54d-8403-7279-9e9b-8bfc93d5ace3",
        "storage_key": "property/6767906449166910/019eb54d-8403-7279-9e9b-8bfc93d5ace3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and yoga accessories for your wellness routine.",
      "link": "false",
      "alt_text": "Fitness center with elliptical machines, stability balls, resistance bands, and a yoga mat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_FitnessCenterElipticals.jpg"
    },
    {
      "id": "ec_f6961d0ddc802b96faacdb19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-84a3-77c4-a06b-6cd2530db5b4.webp",
      "image_media": {
        "alt_text": "Gym equipment including cable machines, leg press, and dumbbells.",
        "public_id": "019eb54d-84a3-77c4-a06b-6cd2530db5b4",
        "storage_key": "property/6767906449166910/019eb54d-84a3-77c4-a06b-6cd2530db5b4.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a variety of machines and free weights to help you achieve your fitness goals.",
      "link": "false",
      "alt_text": "Gym equipment including cable machines, leg press, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_FitnessCenterMachines(1).jpg"
    },
    {
      "id": "ec_0f21917de69844afb562af7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-72ad-7351-aac3-a3cc013f584d.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, benches, and dumbbells.",
        "public_id": "019eb54d-72ad-7351-aac3-a3cc013f584d",
        "storage_key": "property/6767906449166910/019eb54d-72ad-7351-aac3-a3cc013f584d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Our community fitness center is fully equipped with cardio machines, weight machines, and free weights for your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, benches, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_FitnessCenter(1).jpg"
    },
    {
      "id": "ec_b984432bdf8b732bd447f461",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c14-2923-72f3-b673-0021c14e1f67.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background",
        "public_id": "019d1c14-2923-72f3-b673-0021c14e1f67",
        "storage_key": "property/6767906449166910/019d1c14-2923-72f3-b673-0021c14e1f67.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the community pool, surrounded by comfortable lounge chairs and scenic apartment buildings.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_CA_Roseville_LapSizeSwimmingPoolClubhouseCloseUp.jpg"
    },
    {
      "id": "ec_865ffacb910ec7d53a1349b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-902b-726e-8e84-74126ed2e988.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and clubhouse area with lounge chairs and tables.",
        "public_id": "019d2e3c-902b-726e-8e84-74126ed2e988",
        "storage_key": "property/6767906449166910/019d2e3c-902b-726e-8e84-74126ed2e988.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. The adjacent clubhouse provides additional amenities for your relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and clubhouse area with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_CA_Roseville_LapSizeSwimmingPool.jpg"
    },
    {
      "id": "ec_251c371e0f1bb95489a14d54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c14-29ff-73aa-a1c5-6213171b81c3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, overlooking apartment buildings.",
        "public_id": "019d1c14-29ff-73aa-a1c5-6213171b81c3",
        "storage_key": "property/6767906449166910/019d1c14-29ff-73aa-a1c5-6213171b81c3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, overlooking apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_CA_Roseville_LapSizeSwimmingPoolSideView.jpg"
    },
    {
      "id": "ec_7271d33cf10db6d94be38fe2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d1c14-298c-77f8-a52e-3f28db129779.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
        "public_id": "019d1c14-298c-77f8-a52e-3f28db129779",
        "storage_key": "property/6767906449166910/019d1c14-298c-77f8-a52e-3f28db129779.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and hot tub, complete with comfortable lounge chairs and convenient seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_CA_Roseville_LapSizeSwimmingPoolandSpa.jpg"
    },
    {
      "id": "ec_a92e11b25582fd8d0e7e25f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-a31c-7759-8e6b-e4db2e1a197c.webp",
      "image_media": {
        "alt_text": "Playground and pool area at apartment complex.",
        "public_id": "019eb54d-a31c-7759-8e6b-e4db2e1a197c",
        "storage_key": "property/6767906449166910/019eb54d-a31c-7759-8e6b-e4db2e1a197c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor amenities like the playground and swimming pool at this apartment community. Perfect for families and relaxation.",
      "link": "false",
      "alt_text": "Playground and pool area at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_PoolPlayground.jpg"
    },
    {
      "id": "ec_19bbcae729f6b7a96c6d5556",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d291e-24b0-70bc-b3f1-26f41659f99c.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides, surrounded by a black fence and trees.",
        "public_id": "019d291e-24b0-70bc-b3f1-26f41659f99c",
        "storage_key": "property/6767906449166910/019d291e-24b0-70bc-b3f1-26f41659f99c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring modern play structures perfect for children of all ages. A safe and engaging space for family recreation.",
      "link": "false",
      "alt_text": "Playground with swings and slides, surrounded by a black fence and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Playground.jpg"
    },
    {
      "id": "ec_1aaa2f966ac1170926eae7d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-e2a9-77bf-b715-031cb2c64e08.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a picnic area and barbecue grills in the foreground.",
        "public_id": "019d334a-e2a9-77bf-b715-031cb2c64e08",
        "storage_key": "property/6767906449166910/019d334a-e2a9-77bf-b715-031cb2c64e08.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy the outdoors at this apartment community, featuring a picnic area with barbecue grills and ample green space.",
      "link": "false",
      "alt_text": "Apartment building exterior with a picnic area and barbecue grills in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_PicnicBBQAmenity.jpg"
    },
    {
      "id": "ec_96fa1686c708718d09aabb1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8d03-768a-ae14-f28cf237adc3.webp",
      "image_media": {
        "alt_text": "Amazon Hub parcel lockers for resident package delivery.",
        "public_id": "019d2e3c-8d03-768a-ae14-f28cf237adc3",
        "storage_key": "property/6767906449166910/019d2e3c-8d03-768a-ae14-f28cf237adc3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Convenient Amazon Hub parcel lockers are available for residents to securely receive packages at any time.",
      "link": "false",
      "alt_text": "Amazon Hub parcel lockers for resident package delivery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_SelfServePackageLockersSideView.jpg"
    },
    {
      "id": "ec_804acbf3945034a5f70338ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8d61-7689-bb0a-d48f842e0c77.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers with an interactive screen and keypad",
        "public_id": "019d2e3c-8d61-7689-bb0a-d48f842e0c77",
        "storage_key": "property/6767906449166910/019d2e3c-8d61-7689-bb0a-d48f842e0c77.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Secure Amazon Hub package lockers available for residents, providing convenient package delivery and retrieval.",
      "link": "false",
      "alt_text": "Amazon Hub package lockers with an interactive screen and keypad",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_SelfServePackageLockers.jpg"
    },
    {
      "id": "ec_7ccfe042a1be70a82d9393dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d291e-23ea-723d-95e2-d88b69b44296.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and stairs",
        "public_id": "019d291e-23ea-723d-95e2-d88b69b44296",
        "storage_key": "property/6767906449166910/019d291e-23ea-723d-95e2-d88b69b44296.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior view of a well-maintained apartment building, showcasing its architecture and landscaping. This image highlights the property's welcoming facade and outdoor spaces.",
      "link": "false",
      "alt_text": "Exterior of apartment building with balconies and stairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BuildingExteriorEntry.jpg"
    },
    {
      "id": "ec_f2b03fedc75663467ac83774",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d291e-2452-703c-a78c-5c3f0ba2a3c5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone accents and balconies.",
        "public_id": "019d291e-2452-703c-a78c-5c3f0ba2a3c5",
        "storage_key": "property/6767906449166910/019d291e-2452-703c-a78c-5c3f0ba2a3c5.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring stone accents, private balconies, and lush landscaping. Perfect for a serene living experience.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BuildingExteriorLandscaping.jpg"
    },
    {
      "id": "ec_282f4d9ce65eadfce4b7c30d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d291e-282d-720d-b59f-82af604ea949.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone accents and balconies.",
        "public_id": "019d291e-282d-720d-b59f-82af604ea949",
        "storage_key": "property/6767906449166910/019d291e-282d-720d-b59f-82af604ea949.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Showcasing the elegant exterior design of our apartment buildings, featuring beautiful stone accents and private balconies for residents.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BuildingExteriorWalkingPath.jpg"
    },
    {
      "id": "ec_50d777009b10e03d0b4df821",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-a9e4-768e-8c36-1196bc1d59f3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with green grass and trees.",
        "public_id": "019d2e3c-a9e4-768e-8c36-1196bc1d59f3",
        "storage_key": "property/6767906449166910/019d2e3c-a9e4-768e-8c36-1196bc1d59f3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Charming apartment building exterior with lush green landscaping, perfect for a peaceful living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with green grass and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BuildingExteriorGreenSpace.jpg"
    },
    {
      "id": "ec_5bb246fab9448bb32ec77123",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8dc4-76cc-be6d-a17797e6d0f7.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with parking lot and covered parking spaces.",
        "public_id": "019d2e3c-8dc4-76cc-be6d-a17797e6d0f7",
        "storage_key": "property/6767906449166910/019d2e3c-8dc4-76cc-be6d-a17797e6d0f7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing the architecture and surrounding parking facilities.",
      "link": "false",
      "alt_text": "Exterior of apartment building with parking lot and covered parking spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_BuildingExterior Carports.jpg"
    },
    {
      "id": "ec_6903b7883fe9f5bc4c75b6f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8ef7-72a9-b547-57dfb59754c8.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with garages and balconies.",
        "public_id": "019d2e3c-8ef7-72a9-b547-57dfb59754c8",
        "storage_key": "property/6767906449166910/019d2e3c-8ef7-72a9-b547-57dfb59754c8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing garages and balconies under a cloudy sky.",
      "link": "false",
      "alt_text": "Apartment building exterior with garages and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_AttachedGarages.jpg"
    },
    {
      "id": "ec_24636cf1efb90dac0096b59a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8fbf-71ff-8c29-743705f0de3b.webp",
      "image_media": {
        "alt_text": "Apartment building with garages in a row under a sunny sky.",
        "public_id": "019d2e3c-8fbf-71ff-8c29-743705f0de3b",
        "storage_key": "property/6767906449166910/019d2e3c-8fbf-71ff-8c29-743705f0de3b.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Garages are lined up next to an apartment building, providing convenient parking options for residents.",
      "link": "false",
      "alt_text": "Apartment building with garages in a row under a sunny sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_DetachedGarages.jpg"
    },
    {
      "id": "ec_6629670dff1d409bcd163890",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, microwave, stove, and double sink.",
        "public_id": "019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d",
        "storage_key": "property/6767906449166910/019d2e3c-8dc5-758a-81e1-bd9f3bb4dc1d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring light wood cabinetry, granite countertops, and stainless steel appliances including a refrigerator, microwave, and stove.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel refrigerator, microwave, stove, and double sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1KitchenPantry.jpg"
    },
    {
      "id": "ec_1b27534df43aa9f7ea3b0c6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d2e3c-8ef0-749a-a751-f1bcbea97751.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a round table and chairs, microwave, and granite countertops.",
        "public_id": "019d2e3c-8ef0-749a-a751-f1bcbea97751",
        "storage_key": "property/6767906449166910/019d2e3c-8ef0-749a-a751-f1bcbea97751.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring a round table with upholstered chairs, a microwave, and stylish granite countertops. Perfect for meals and entertaining.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a round table and chairs, microwave, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1KitchenDiningRoomView.jpg"
    },
    {
      "id": "ec_f873cf95f1f819aa520be031",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-ddfe-72bc-98f6-bb889fad4693.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with light wood cabinets, stainless steel appliances, and a round dining table with chairs.",
        "public_id": "019d334a-ddfe-72bc-98f6-bb889fad4693",
        "storage_key": "property/6767906449166910/019d334a-ddfe-72bc-98f6-bb889fad4693.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen and dining space featuring light wood cabinetry, modern appliances, and a stylish dining set, perfect for everyday living.",
      "link": "false",
      "alt_text": "Kitchen and dining area with light wood cabinets, stainless steel appliances, and a round dining table with chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1DiningRoomKitchenView.jpg"
    },
    {
      "id": "ec_cd90c2156d8c1e46b690a06d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de24-7378-87a3-9bb2b01375dd.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and dining area with table and chairs.",
        "public_id": "019d334a-de24-7378-87a3-9bb2b01375dd",
        "storage_key": "property/6767906449166910/019d334a-de24-7378-87a3-9bb2b01375dd.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furniture, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, coffee table, and dining area with table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1LivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_1a002b68cf7d50ad11308b0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de07-71d5-aebb-de316f274d10.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, chairs, bookshelf, and sliding glass door to a patio.",
        "public_id": "019d334a-de07-71d5-aebb-de316f274d10",
        "storage_key": "property/6767906449166910/019d334a-de07-71d5-aebb-de316f274d10.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a gray sofa, accent chairs, a modern bookshelf, and a sliding glass door leading to an outdoor patio space.",
      "link": "false",
      "alt_text": "Living room with a sofa, chairs, bookshelf, and sliding glass door to a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1LivingRoomEntry.jpg"
    },
    {
      "id": "ec_f22dfe5ed95cd43508871cdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-ddfc-70cd-909e-851442b91eda.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, accent chairs, coffee table, and bookshelves.",
        "public_id": "019d334a-ddfc-70cd-909e-851442b91eda",
        "storage_key": "property/6767906449166910/019d334a-ddfc-70cd-909e-851442b91eda.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable gray sofa, two accent chairs, a round coffee table, and ample storage with bookshelves.",
      "link": "false",
      "alt_text": "Living room with gray sofa, accent chairs, coffee table, and bookshelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1LivingRoomPatio.jpg"
    },
    {
      "id": "ec_f40b1f6c384df8350795c970",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de79-721f-9108-54e2f29c32d1.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019d334a-de79-721f-9108-54e2f29c32d1",
        "storage_key": "property/6767906449166910/019d334a-de79-721f-9108-54e2f29c32d1.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen-size bed with a decorative comforter and pillows, a tall dresser, a nightstand, and a ceiling fan.",
      "link": "false",
      "alt_text": "A bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1PrimaryBedroom.jpg"
    },
    {
      "id": "ec_d49d9553e2f3bd6c2ff3b106",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de03-71f8-8e4a-d84ee765a542.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with two clothes rods and beige walls.",
        "public_id": "019d334a-de03-71f8-8e4a-d84ee765a542",
        "storage_key": "property/6767906449166910/019d334a-de03-71f8-8e4a-d84ee765a542.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and rod space for all your storage needs.",
      "link": "false",
      "alt_text": "Empty walk-in closet with two clothes rods and beige walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1PrimaryBedroomCloset.jpg"
    },
    {
      "id": "ec_52ba977a7f22d152b9b1dbde",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de6e-76c0-b594-ea65b0a65b3e.webp",
      "image_media": {
        "alt_text": "Master bedroom with a queen-sized bed, nightstand, lamp, dresser, and decorative mirror.",
        "public_id": "019d334a-de6e-76c0-b594-ea65b0a65b3e",
        "storage_key": "property/6767906449166910/019d334a-de6e-76c0-b594-ea65b0a65b3e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious master bedroom, featuring a queen-sized bed and ample storage. The room is well-lit by natural light from the windows.",
      "link": "false",
      "alt_text": "Master bedroom with a queen-sized bed, nightstand, lamp, dresser, and decorative mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1SecondBedroom.jpg"
    },
    {
      "id": "ec_59f4d9906e23dbc9e98f8a29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-e245-7189-88e4-eb99dcb781f1.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark wood dresser, queen-size bed with patterned comforter and pillows, and a closet.",
        "public_id": "019d334a-e245-7189-88e4-eb99dcb781f1",
        "storage_key": "property/6767906449166910/019d334a-e245-7189-88e4-eb99dcb781f1.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a spacious closet and elegant decor, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a dark wood dresser, queen-size bed with patterned comforter and pillows, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1SecondBedroomCloset.jpg"
    },
    {
      "id": "ec_3d933cb5782468c0ddc091bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d334a-de6f-70ed-be27-e0ae7ca6b3df.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, toilet, and laundry area with washer and dryer.",
        "public_id": "019d334a-de6f-70ed-be27-e0ae7ca6b3df",
        "storage_key": "property/6767906449166910/019d334a-de6f-70ed-be27-e0ae7ca6b3df.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with granite countertops and ample storage, adjacent to a convenient laundry area with a full-size washer and dryer.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, toilet, and laundry area with washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1HallBathroomLaundry.jpg"
    },
    {
      "id": "ec_0542ec941bd47506578d38d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48af-778b-9357-a768c983a6be.webp",
      "image_media": {
        "alt_text": "Updated bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019d3852-48af-778b-9357-a768c983a6be",
        "storage_key": "property/6767906449166910/019d3852-48af-778b-9357-a768c983a6be.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in the updated bathroom featuring a vanity with ample counter space, a toilet, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "Updated bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1HallBathroom.jpg"
    },
    {
      "id": "ec_38e1bc1fcc3df770b5603f84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4b03-73ae-b5c5-932360e4fc27.webp",
      "image_media": {
        "alt_text": "Bathroom with granite countertop, vanity, toilet, and mirror",
        "public_id": "019d3852-4b03-73ae-b5c5-932360e4fc27",
        "storage_key": "property/6767906449166910/019d3852-4b03-73ae-b5c5-932360e4fc27.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a granite-top vanity with ample counter space, a large mirror, and a separate toilet area. This well-appointed bathroom offers both style and functionality.",
      "link": "false",
      "alt_text": "Bathroom with granite countertop, vanity, toilet, and mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1PrimaryBathroom.jpg"
    },
    {
      "id": "ec_ba35dbb696c151708b81b510",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4cfb-7448-bb7e-026bf3ecbb21.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, shower, and vanity.",
        "public_id": "019d3852-4cfb-7448-bb7e-026bf3ecbb21",
        "storage_key": "property/6767906449166910/019d3852-4cfb-7448-bb7e-026bf3ecbb21.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and well-appointed bathroom featuring a bathtub, shower, and vanity area. The bathroom is decorated with a crab-themed picture and fresh flowers.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, shower, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model1PrimaryBathroomShower.jpg"
    },
    {
      "id": "ec_56f606c303e2f4ba5a079a83",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019d3852-4973-73a9-9b0e-194dacaa1a53",
        "storage_key": "property/6767906449166910/019d3852-4973-73a9-9b0e-194dacaa1a53.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this bright and spacious kitchen, featuring stainless steel appliances, ample cabinet space, and granite countertops.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2Kitchen(1).jpg"
    },
    {
      "id": "ec_04fdb042643a6a48a4aa3692",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
      "image_media": {
        "alt_text": "A modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d3852-48b7-7619-9182-2e8749270a18",
        "storage_key": "property/6767906449166910/019d3852-48b7-7619-9182-2e8749270a18.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen, complete with modern appliances and ample counter space.",
      "link": "false",
      "alt_text": "A modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2KitchenBar.jpg"
    },
    {
      "id": "ec_85cc58314da7b6e5fcd2273b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4a3b-77a9-8337-4989c6c8aaa0.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs next to kitchen.",
        "public_id": "019d3852-4a3b-77a9-8337-4989c6c8aaa0",
        "storage_key": "property/6767906449166910/019d3852-4a3b-77a9-8337-4989c6c8aaa0.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy this bright dining area with a table, chairs, and a view of the kitchen. Perfect for meals with friends and family.",
      "link": "false",
      "alt_text": "Dining area with table and chairs next to kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2KitchenDiningRoom.jpg"
    },
    {
      "id": "ec_fa2b9a36aed877ac856251e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-48ac-7752-84ef-138a67f1db9c.webp",
      "image_media": {
        "alt_text": "Living room with stylish chairs and sofa, leading into a kitchen area.",
        "public_id": "019d3852-48ac-7752-84ef-138a67f1db9c",
        "storage_key": "property/6767906449166910/019d3852-48ac-7752-84ef-138a67f1db9c.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush sofa and accent chairs, with a glimpse into the modern kitchen. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with stylish chairs and sofa, leading into a kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2LivingRoomEntry.jpg"
    },
    {
      "id": "ec_aca301b633ed92f2deb41d24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4e91-74fc-b31f-d94d5ff6900b.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, two chairs, a coffee table, and a dining table.",
        "public_id": "019d3852-4e91-74fc-b31f-d94d5ff6900b",
        "storage_key": "property/6767906449166910/019d3852-4e91-74fc-b31f-d94d5ff6900b.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring comfortable seating and a elegant dining set, perfect for entertaining guests or enjoying a quiet meal at home.",
      "link": "false",
      "alt_text": "Living and dining area with a sofa, two chairs, a coffee table, and a dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2LivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_f620aaf426efef0be48a53e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019eb54d-a042-7528-bec1-6b39f07828a3.webp",
      "image_media": {
        "alt_text": "King-size bed with white headboard and patterned duvet, next to nightstands with lamps. A ceiling fan is visible above.",
        "public_id": "019eb54d-a042-7528-bec1-6b39f07828a3",
        "storage_key": "property/6767906449166910/019eb54d-a042-7528-bec1-6b39f07828a3.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush king-size bed and ample natural light from the large window. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "King-size bed with white headboard and patterned duvet, next to nightstands with lamps. A ceiling fan is visible above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2SecondBedroom(1).jpg"
    },
    {
      "id": "ec_27dfaf4e7fc252fa4e150042",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3852-4a3e-74dc-8b76-583915893253.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed and nightstand next to a laundry room with a washer and dryer.",
        "public_id": "019d3852-4a3e-74dc-8b76-583915893253",
        "storage_key": "property/6767906449166910/019d3852-4a3e-74dc-8b76-583915893253.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Experience convenience with an in-unit washer and dryer, alongside a comfortable bedroom space.",
      "link": "false",
      "alt_text": "Bedroom with a bed and nightstand next to a laundry room with a washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2PrimaryBedroomLaundry.jpg"
    },
    {
      "id": "ec_d55eb7140d570a14088be986",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-82a3-75bb-a20f-7f5103be710b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving and hanging rods.",
        "public_id": "019d3862-82a3-75bb-a20f-7f5103be710b",
        "storage_key": "property/6767906449166910/019d3862-82a3-75bb-a20f-7f5103be710b.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with shelving and hanging rods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2PrimaryBedroomCloset.jpg"
    },
    {
      "id": "ec_d698a21d21f279f2bcb4e0ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-82a6-7299-aae7-07e6c3862c34.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and lighting, adjacent to a toilet and shower.",
        "public_id": "019d3862-82a6-7299-aae7-07e6c3862c34",
        "storage_key": "property/6767906449166910/019d3862-82a6-7299-aae7-07e6c3862c34.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a granite countertop, modern sink, and bright vanity lighting, alongside a toilet and a convenient shower/tub combination.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and lighting, adjacent to a toilet and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2PrimaryBathroom.jpg"
    },
    {
      "id": "ec_5d2ad03d0ef0503044e01aa3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-8493-720e-926b-ba5ac6c206b6.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, towels, and artwork.",
        "public_id": "019d3862-8493-720e-926b-ba5ac6c206b6",
        "storage_key": "property/6767906449166910/019d3862-8493-720e-926b-ba5ac6c206b6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a granite-top vanity with a sink, ample storage, and a large mirror. Decorated with modern artwork and plush towels.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, mirror, towels, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2HallBathroom.jpg"
    },
    {
      "id": "ec_4c04ed2b83c7746d2cc32744",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-82a6-7299-aae7-01f562ef5022.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, granite countertop, and a bathtub with a shower curtain.",
        "public_id": "019d3862-82a6-7299-aae7-01f562ef5022",
        "storage_key": "property/6767906449166910/019d3862-82a6-7299-aae7-01f562ef5022.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a toilet, vanity with granite countertop, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, granite countertop, and a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2HallBathroomShower.jpg"
    },
    {
      "id": "ec_553e5efa03c1a32dc0a9073d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d3862-830d-764d-ae44-d132d3b7ddca.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and view of community",
        "public_id": "019d3862-830d-764d-ae44-d132d3b7ddca",
        "storage_key": "property/6767906449166910/019d3862-830d-764d-ae44-d132d3b7ddca.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, overlooking the community grounds.",
      "link": "false",
      "alt_text": "Balcony with two chairs and view of community",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stoneridge_Roseville_CA_Model2DeckView.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_48e11aa1-88d7-4181-a74b-e42056270106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-18f8-718f-8e6f-45609b33ec1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-18f8-718f-8e6f-45609b33ec1c",
        "storage_key": "property/6767906449166910/019d08b1-18f8-718f-8e6f-45609b33ec1c.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-249d-7261-ae51-2976f05b8170",
        "storage_key": "property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1782f639-d5f2-4aea-a102-8a8a400807d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-7374-7588-82eb-60833743a854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7374-7588-82eb-60833743a854",
        "storage_key": "property/6767906449166910/019d08b1-7374-7588-82eb-60833743a854.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-249d-7261-ae51-2976f05b8170",
        "storage_key": "property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b14325aa-76b8-4701-8fe2-4da68a91f0a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-87b4-73fc-aba2-97ce58019a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-87b4-73fc-aba2-97ce58019a5c",
        "storage_key": "property/6767906449166910/019d08b0-87b4-73fc-aba2-97ce58019a5c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-249d-7261-ae51-2976f05b8170",
        "storage_key": "property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c8e73a60-a841-4e2c-9185-ff009ade376a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-9a86-7752-ac81-45ea656cddd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-9a86-7752-ac81-45ea656cddd9",
        "storage_key": "property/6767906449166910/019d08b0-9a86-7752-ac81-45ea656cddd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-249d-7261-ae51-2976f05b8170",
        "storage_key": "property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8fea8224-5df1-480f-934a-9dc1259f232e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-7670-735a-9ade-c7d22816827a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7670-735a-9ade-c7d22816827a",
        "storage_key": "property/6767906449166910/019d08b1-7670-735a-9ade-c7d22816827a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-249d-7261-ae51-2976f05b8170",
        "storage_key": "property/6767906449166910/019d08b1-249d-7261-ae51-2976f05b8170.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5855e207-668b-43c0-8f97-154c4e965043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-adab-71ce-ad79-9fcdcb6ad52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-adab-71ce-ad79-9fcdcb6ad52d",
        "storage_key": "property/6767906449166910/019d08b0-adab-71ce-ad79-9fcdcb6ad52d.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2abf-72fe-a26e-dd893c68f038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2abf-72fe-a26e-dd893c68f038",
        "storage_key": "property/6767906449166910/019d08b1-2abf-72fe-a26e-dd893c68f038.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1e09f2bd-9ee1-40c8-8d1d-632c69b38053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-acde-713a-b8b1-40dee7a42e4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-acde-713a-b8b1-40dee7a42e4f",
        "storage_key": "property/6767906449166910/019d08b0-acde-713a-b8b1-40dee7a42e4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2499-76bf-8a98-4384c497096a",
        "storage_key": "property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_369cb636-50c7-472e-834d-254bef52f1b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-77f2-776d-8856-b1d1f614f1f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-77f2-776d-8856-b1d1f614f1f7",
        "storage_key": "property/6767906449166910/019d08b1-77f2-776d-8856-b1d1f614f1f7.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2499-76bf-8a98-4384c497096a",
        "storage_key": "property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3f129416-ca11-49c8-8c82-ad1cf46efef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-aa31-72a8-8478-465771b2a5b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-aa31-72a8-8478-465771b2a5b4",
        "storage_key": "property/6767906449166910/019d08b0-aa31-72a8-8478-465771b2a5b4.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2499-76bf-8a98-4384c497096a",
        "storage_key": "property/6767906449166910/019d08b1-2499-76bf-8a98-4384c497096a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_58e31e98-7b17-4d25-81e8-0c57dc65081b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-7ae3-7749-b3ff-f665265e88b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7ae3-7749-b3ff-f665265e88b8",
        "storage_key": "property/6767906449166910/019d08b1-7ae3-7749-b3ff-f665265e88b8.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2abf-72fe-a26e-dd893c68f038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2abf-72fe-a26e-dd893c68f038",
        "storage_key": "property/6767906449166910/019d08b1-2abf-72fe-a26e-dd893c68f038.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_64a5724b-c104-4383-855a-cc3c382408b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-bf0c-77dc-b34c-eab90f762bd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-bf0c-77dc-b34c-eab90f762bd3",
        "storage_key": "property/6767906449166910/019d08b0-bf0c-77dc-b34c-eab90f762bd3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a62-72f3-9072-0739ed000f6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a62-72f3-9072-0739ed000f6c",
        "storage_key": "property/6767906449166910/019d08b1-2a62-72f3-9072-0739ed000f6c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f396a36d-89a3-4912-b53a-72ff7787f8db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-7d95-708c-a1cb-ba4dd78a4d75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7d95-708c-a1cb-ba4dd78a4d75",
        "storage_key": "property/6767906449166910/019d08b1-7d95-708c-a1cb-ba4dd78a4d75.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a62-72f3-9072-0739ed000f6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a62-72f3-9072-0739ed000f6c",
        "storage_key": "property/6767906449166910/019d08b1-2a62-72f3-9072-0739ed000f6c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_515b1d6d-8e9f-41a9-a369-56b463a0a644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-c4c9-72ed-9aa5-9bc459881259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-c4c9-72ed-9aa5-9bc459881259",
        "storage_key": "property/6767906449166910/019d08b0-c4c9-72ed-9aa5-9bc459881259.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0771b53b-2afc-4a3c-92ba-84806bfdfe81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-7faf-729d-bbdb-23aa49924604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7faf-729d-bbdb-23aa49924604",
        "storage_key": "property/6767906449166910/019d08b1-7faf-729d-bbdb-23aa49924604.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_41154550-aab7-44d3-96c9-b0f7c4db58ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-d0ba-71bc-a3b5-b844eb57ddf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-d0ba-71bc-a3b5-b844eb57ddf9",
        "storage_key": "property/6767906449166910/019d08b0-d0ba-71bc-a3b5-b844eb57ddf9.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2ff2-747c-8f6d-02aab47cf755",
        "storage_key": "property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f939f944-c6e3-4ce2-ab86-4df97f9c056e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-c623-77b9-8894-f61a973b94c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-c623-77b9-8894-f61a973b94c5",
        "storage_key": "property/6767906449166910/019d08b0-c623-77b9-8894-f61a973b94c5.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2ff2-747c-8f6d-02aab47cf755",
        "storage_key": "property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3213f03a-f0ce-4255-adeb-713cf6128753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Folsom Prison Museum",
      "poi_type": "Entertainment",
      "poi_address": "312 3rd St, Represa, CA 95671, USA",
      "poi_short_description": "Prison artifacts & Johnny Cash memorabilia fill this small museum & gift shop in an old home.",
      "poi_long_description": "Prison artifacts & Johnny Cash memorabilia fill this small museum & gift shop in an old home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-82de-725e-9613-75e24b2c16bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-82de-725e-9613-75e24b2c16bd",
        "storage_key": "property/6767906449166910/019d08b1-82de-725e-9613-75e24b2c16bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bighouseprisonmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119073733026558469&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "folsom-prison-museum",
      "poi_latitude": "38.6923979",
      "poi_longitude": "-121.1609592",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 916-985-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2ff2-747c-8f6d-02aab47cf755",
        "storage_key": "property/6767906449166910/019d08b1-2ff2-747c-8f6d-02aab47cf755.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAW_gz_HjmoARBbJsGKbiTpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f923f7f2-237a-4851-9c55-37bfa57d9b36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-e764-74b9-9cca-c7595b9689c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e764-74b9-9cca-c7595b9689c8",
        "storage_key": "property/6767906449166910/019d08b0-e764-74b9-9cca-c7595b9689c8.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e755a3fc-aeef-4cad-8c23-f56f5354d15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "336 N Sunrise Ave, Roseville, CA 95661, USA",
      "poi_short_description": "Chain fitness center with cardio and strength machines, a pool, a sauna, and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-eaaa-7308-ba39-a2af926cf36d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-eaaa-7308-ba39-a2af926cf36d",
        "storage_key": "property/6767906449166910/019d08b0-eaaa-7308-ba39-a2af926cf36d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/roseville-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5665805128877314491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7539734",
      "poi_longitude": "-121.261129",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-772-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUHYiIkfm4ARu5FR-b77oE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_36816929-ea86-4135-8bd1-35229c67875c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-875c-75f8-8000-22e318559d4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-875c-75f8-8000-22e318559d4d",
        "storage_key": "property/6767906449166910/019d08b1-875c-75f8-8000-22e318559d4d.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_89eade68-b429-4990-b30d-477eb7956c0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "VCA Loomis Basin Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Sierra College Blvd, Loomis, CA 95650, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-89c0-7516-abb7-3db60af43e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-89c0-7516-abb7-3db60af43e12",
        "storage_key": "property/6767906449166910/019d08b1-89c0-7516-abb7-3db60af43e12.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/loomis-basin?utm_source=maps&utm_medium=organic&utm_campaign=AU_935",
      "poi_directions_map_url": "https://maps.google.com/?cid=3050520726901175039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-loomis-basin-veterinary-clinic",
      "poi_latitude": "38.81533",
      "poi_longitude": "-121.207103",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-652-5816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-uKVdAem4AR_zLpUnCgVSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e746c9c4-3f02-4c8c-83f0-9e8c6e3c21e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-8b11-7434-b171-7c26f42965f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b11-7434-b171-7c26f42965f0",
        "storage_key": "property/6767906449166910/019d08b1-8b11-7434-b171-7c26f42965f0.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9bcb2aae-60db-4b27-b18a-761104bef4c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1159 Roseville Square Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Clean, friendly, well-equipped facility that's part of a chain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-8870-70fe-aa4b-47f647914062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8870-70fe-aa4b-47f647914062",
        "storage_key": "property/6767906449166910/019d08b1-8870-70fe-aa4b-47f647914062.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/roseville-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11658269411521409879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7468683",
      "poi_longitude": "-121.2740643",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-604-8235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0EtYWchm4ARVzOJ-UJ-yqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d8b4418a-f949-45b2-92cc-fa4a3abea1e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the gym is a decent size and the front desk staff is usually friendly. They also like the welcoming atmosphere and the willingness of members to share advice. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-8dbc-7159-847f-c636a4351a38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8dbc-7159-847f-c636a4351a38",
        "storage_key": "property/6767906449166910/019d08b1-8dbc-7159-847f-c636a4351a38.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3de5a9a8-0b90-43ae-9b48-8fb96660c4cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large variety of equipment, a pool, a sauna, and a steam room. They also highlight the friendly staff, the beautiful views, and the good vibe.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-8f3b-738e-ac19-a6a5014378cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8f3b-738e-ac19-a6a5014378cd",
        "storage_key": "property/6767906449166910/019d08b1-8f3b-738e-ac19-a6a5014378cd.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7fd2ac63-067c-4652-a04a-124f9c5c2ef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-da8e-7611-a850-e8f1ca1bf519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-da8e-7611-a850-e8f1ca1bf519",
        "storage_key": "property/6767906449166910/019d08b0-da8e-7611-a850-e8f1ca1bf519.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2fec-75cb-88ca-45298f932630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2fec-75cb-88ca-45298f932630",
        "storage_key": "property/6767906449166910/019d08b1-2fec-75cb-88ca-45298f932630.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6dabda2a-9355-49d7-b392-65ad2018091a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-9538-7509-8193-179e8cf4d37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9538-7509-8193-179e8cf4d37e",
        "storage_key": "property/6767906449166910/019d08b1-9538-7509-8193-179e8cf4d37e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2fec-75cb-88ca-45298f932630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2fec-75cb-88ca-45298f932630",
        "storage_key": "property/6767906449166910/019d08b1-2fec-75cb-88ca-45298f932630.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1559dd0f-d0b3-474f-b5be-d9b1e9042301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-016d-76cd-b03d-094c250c7fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-016d-76cd-b03d-094c250c7fdf",
        "storage_key": "property/6767906449166910/019d08b1-016d-76cd-b03d-094c250c7fdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-309c-778e-9312-648c9810d040",
        "storage_key": "property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4ed8b166-d66b-4d8f-9912-b57e15a7a83b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Black Miners Bar",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Folsom, CA 95630, USA",
      "poi_short_description": "Waterside park featuring kayak and paddleboard rentals as well as picnic spots and a campground.",
      "poi_long_description": "People say this state park offers kayaking, paddle boarding, and a riverside walk. They highlight the quiet and relaxed vibe, and the availability of picnic areas and restrooms. They also like the spacious area with covered areas and shade, and the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-9591-77d4-a3ff-27a4f31d3361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9591-77d4-a3ff-27a4f31d3361",
        "storage_key": "property/6767906449166910/019d08b1-9591-77d4-a3ff-27a4f31d3361.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parks.ca.gov/?page_id=27866",
      "poi_directions_map_url": "https://maps.google.com/?cid=13160319826641908859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "black-miners-bar",
      "poi_latitude": "38.6798423",
      "poi_longitude": "-121.1869149",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-309c-778e-9312-648c9810d040",
        "storage_key": "property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG283103hmoARe3SF7SfZorY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_42c7789b-0461-45e4-994b-4d77b8e6f564",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-966a-70dc-871d-3f72ab21f1fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-966a-70dc-871d-3f72ab21f1fb",
        "storage_key": "property/6767906449166910/019d08b1-966a-70dc-871d-3f72ab21f1fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-309c-778e-9312-648c9810d040",
        "storage_key": "property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b9bc3a8-61ef-4f3b-b566-789f0665254d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Rusch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7801 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Outdoor skating & biking spot with concrete surface, numerous unique features & lighting at night.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including pickleball courts, tennis courts, a swimming pool, playgrounds, and walking trails. They also highlight the clean and well-maintained grounds, and the spacious open areas perfect for picnics and recreational activities.\n\nOther reviews mention there can be homeless people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-967b-71c9-acb8-6b9cb8ae8bb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-967b-71c9-acb8-6b9cb8ae8bb2",
        "storage_key": "property/6767906449166910/019d08b1-967b-71c9-acb8-6b9cb8ae8bb2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sunriseparks.com/rusch-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352438582190195855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rusch-community-park",
      "poi_latitude": "38.70897069999999",
      "poi_longitude": "-121.2912232",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-309c-778e-9312-648c9810d040",
        "storage_key": "property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCebD9pDfmoARj8SW8AUd5AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_30949a7c-cf74-4a63-9c93-b187a03322da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b0-f9a1-70de-9608-0e37182fd502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f9a1-70de-9608-0e37182fd502",
        "storage_key": "property/6767906449166910/019d08b0-f9a1-70de-9608-0e37182fd502.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-309c-778e-9312-648c9810d040",
        "storage_key": "property/6767906449166910/019d08b1-309c-778e-9312-648c9810d040.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9c377cd-db2b-4cba-a51b-4aea56bb934e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-1898-776d-8ee0-c19313515815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-1898-776d-8ee0-c19313515815",
        "storage_key": "property/6767906449166910/019d08b1-1898-776d-8ee0-c19313515815.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d793d69-655c-49ad-a7fb-a0698e39c21c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-9ce1-74ea-aef9-c2af9803ffbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9ce1-74ea-aef9-c2af9803ffbd",
        "storage_key": "property/6767906449166910/019d08b1-9ce1-74ea-aef9-c2af9803ffbd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_80b98aea-2337-43a8-8b9f-f7e3c0be45da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_47177c62-b2bb-40e3-a2f3-558a599a47c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "Norcanna Farms Cannabis Delivery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-9dc9-7086-adcf-e396ede6eb0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9dc9-7086-adcf-e396ede6eb0a",
        "storage_key": "property/6767906449166910/019d08b1-9dc9-7086-adcf-e396ede6eb0a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://norcannafarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13645295156685364849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norcanna-farms-cannabis-delivery",
      "poi_latitude": "38.69166260000001",
      "poi_longitude": "-121.2721073",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-671-3446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxpQROffmoARcd6WLabTXb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f7d405ec-4403-4832-bf65-be8ab0a51570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-2a60-76fe-9dc0-6f64f98a7ac5",
        "storage_key": "property/6767906449166910/019d08b1-2a60-76fe-9dc0-6f64f98a7ac5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_55d7398f2b880892e28b7e10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_3000326c712076e0fd13464f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_3038ebfc81533142d7c6f8bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_9c27bc81c7384e68487b77d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_3b6ed2f091784ac3a59bfbfe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_3a91862558507615579012f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_a4ba0c4a-d7d1-433a-8f47-ba4ba2d23b1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "rating": "5.0",
      "name": "Isabelle Newcomb",
      "text": "We have been living here for almost 3 months now and are very happy. Apartment was newly renovated when moving in and in pretty good shape, apart from a few things that were fixed fairly quickly. It is a quiet complex, apart from the occasional sound from the neighbors, can’t complain too much. Have have a couple issues needing a maintenance person and they were there to fix it within 2 hours both times. Nice gym and pool. Everyone at the front office is very nice and responsive. We look forward to staying here!",
      "date": "2024-01-09",
      "title": ""
    },
    {
      "id": "custom_2f48439f-1755-4ef4-8cea-9b96afc14edb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "rating": "5.0",
      "name": "Aj",
      "text": "I just wanted to write a review and I have moved from the bay area to this apartment property back in 2019 to 2022 and I have to say that the people that works in the office are really professional, friendly and very helpful. The maintenance people are very Responsive and very nice as well. Everybody in that management is really nice. It’s just that unfortunate. I had to move out of there in 2022 because I bought a house otherwise I would say that I would still be living in that property if I did not buy a home, because that property is very clean well maintained the people are professional and nice and helpful. The maintenance are super.!!!",
      "date": "2024-04-06",
      "title": ""
    },
    {
      "id": "custom_78c32b4c-2ee2-4df9-a089-b6bc78be28ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "rating": "5.0",
      "name": "Lesley Rosas Unstoppable",
      "text": "Our sons new apartment is\nVery nice, homey and situated in a safe neighborhood.",
      "date": "2025-07-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_52974ba9-6c1c-4445-8ec8-0f94b0c79610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4476-c5c6-75b4-ac6b-0c071ca45691.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4476-c5c6-75b4-ac6b-0c071ca45691",
        "storage_key": "property/6767906449166910/019d4476-c5c6-75b4-ac6b-0c071ca45691.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments  - 1 Bedroom 1 Bath 750 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NsFv39hAogg"
    },
    {
      "id": "custom_864ed92d-6b12-4317-a46d-5c1b3b1a4a4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4476-e04d-73f8-9758-b3bc3d74fca4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4476-e04d-73f8-9758-b3bc3d74fca4",
        "storage_key": "property/6767906449166910/019d4476-e04d-73f8-9758-b3bc3d74fca4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments - 2 Bedroom 2 Bath 993 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dHN4tYnChwr"
    },
    {
      "id": "custom_7227d6ea-e02b-48c8-8774-ae060d68c0ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4476-f49e-7473-8d2c-5f6a980ae290.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4476-f49e-7473-8d2c-5f6a980ae290",
        "storage_key": "property/6767906449166910/019d4476-f49e-7473-8d2c-5f6a980ae290.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments - 2 Bedroom 2 Bath 994 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VR8xVKLrjYY"
    },
    {
      "id": "custom_d25c2527-40d1-446d-8569-502ed3c96c82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4477-08c1-77a7-a35f-103515acaa60.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4477-08c1-77a7-a35f-103515acaa60",
        "storage_key": "property/6767906449166910/019d4477-08c1-77a7-a35f-103515acaa60.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments - 2 Bedroom 2 Bath 1077 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=D29aezmn8wJ"
    },
    {
      "id": "custom_19e7c571-02a9-40a3-9e26-72387fa38358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4477-20dc-74da-991c-50a3a49e06e7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4477-20dc-74da-991c-50a3a49e06e7",
        "storage_key": "property/6767906449166910/019d4477-20dc-74da-991c-50a3a49e06e7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments - 3 Bedroom 2 Bath 1276 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZHmGdW8WgBg"
    },
    {
      "id": "custom_f3ab8293-254d-4697-b0ce-7d508b461ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166910/019d4477-34ef-7041-8ee4-4d93ec056878.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4477-34ef-7041-8ee4-4d93ec056878",
        "storage_key": "property/6767906449166910/019d4477-34ef-7041-8ee4-4d93ec056878.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stoneridge Apartments Fitness Center, Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nv9P6zA62RV"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c0-e5eb-7051-9d84-296bb19a1450",
      "lead_source": "LANDING_PAGE",
      "name": "Stoneridge Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-roseville-ca",
      "search_query": "apartments with in-unit laundry Roseville CA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Roseville CA",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Stoneridge Apartments. Nestled in Roseville, CA, our units feature premium amenities tailored to your needs.",
      "page_copy": "Welcome to Stoneridge Apartments, where the modern convenience of in-unit laundry meets the charm of Roseville, CA. Situated in the heart of East Roseville Parkway, our community offers more than just a place to live. Each apartment boasts a washer and dryer, saving you time and providing the ultimate comfort right in your home.\n\nBeyond laundry, enjoy a variety of exceptional amenities such as stainless steel appliances and an efficient dishwasher. Relish in a smoke-free environment and explore the ease of walk-up access. Located in Placer County, our prime location ensures quick access to shopping, dining, and the vibrant culture of Roseville. Discover the perfect blend of luxury and convenience at Stoneridge Apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roseville CA Apartments with In-Unit Laundry",
      "seo_description": "Find apartments with in-unit laundry at Stoneridge in Roseville CA. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-east-roseville-parkway",
      "search_query": "air conditioned apartments East Roseville Parkway",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in East Roseville",
      "h2_subtitle": "Enjoy comfort with air conditioned living at Stoneridge Apartments. Located in East Roseville Parkway, we offer modern amenities designed for ease and style.",
      "page_copy": "Experience relaxation and convenience at Stoneridge Apartments, located in the serene East Roseville Parkway. Our air conditioned apartments provide a perfect retreat from the California heat, ensuring our residents enjoy a cool, comfortable environment year-round.\n\nEach apartment is thoughtfully designed with amenities that enhance everyday living. Enjoy stainless steel appliances and a washer/dryer in every unit, coupled with the benefits of a smoke-free community. The walk-up access provides additional ease, making your day-to-day living more convenient. Positioned in Roseville, CA, Stoneridge Apartments deliver a lifestyle that combines comfort and modern elegance.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in East Roseville",
      "seo_description": "Stay cool in air-conditioned apartments at Stoneridge, East Roseville Parkway. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-with-dishwasher-95661",
      "search_query": "pet friendly apartments with dishwasher 95661",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dishwasher 95661",
      "h2_subtitle": "Find your ideal pet-friendly residence at Stoneridge Apartments in the 95661 area. Enjoy modern conveniences like a dishwasher in each unit.",
      "page_copy": "Welcome home to Stoneridge Apartments, your pet-friendly haven in the heart of the 95661 area. We know how important it is for your furry friends to feel at home. Our community not only welcomes pets but also provides all the modern amenities you desire, including a convenient dishwasher in every apartment.\n\nLocated in East Roseville Parkway, our apartments offer much more than a comfortable living space. Enjoy the modern appeal of stainless steel appliances and hassle-free laundry access with in-unit washer and dryer. Our smoke-free environment and easy walk-up access further enhance your living experience. Discover the joy of living in a community that cares about you and your pets at Stoneridge Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apts with Dishwasher in 95661",
      "seo_description": "Discover pet-friendly apartments in 95661 with dishwasher at Stoneridge. Modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-roseville-ca",
      "search_query": "luxury apartments with pool Roseville CA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Roseville CA",
      "h2_subtitle": "Discover upscale living with a pool at Stoneridge Apartments in Roseville, CA. Enjoy luxury amenities and a prime location near East Roseville Parkway.",
      "page_copy": "Welcome to Stoneridge Apartments, where luxury meets leisure in Roseville, CA. Our exclusive community features a sparkling pool, perfect for relaxing on a sunny California day. Designed with sophisticated style and comfort in mind, our apartments offer residents a truly upscale living experience.\n\nLocated near East Roseville Parkway, Stoneridge Apartments are equipped with top-of-the-line amenities, including stainless steel appliances, in-unit washer/dryer, and a time-saving dishwasher. Enjoy the tranquility of our smoke-free environment and the convenience of walk-up access. Dive into a luxurious lifestyle in one of Roseville’s most desirable communities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Roseville CA",
      "seo_description": "Explore luxury apartments with a pool at Stoneridge in Roseville, CA. Enjoy upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "apartments-high-speed-internet-placer-county",
      "search_query": "apartments with high-speed internet access Placer County",
      "category": "Amenity",
      "h1_title": "Apartments with High-Speed Internet in Placer",
      "h2_subtitle": "Stay connected with high-speed internet access at Stoneridge Apartments, located in vibrant Placer County. Enjoy modern living in a prime location.",
      "page_copy": "At Stoneridge Apartments in Placer County, staying connected has never been easier. Our community offers high-speed internet access, ensuring that you can effortlessly work or unwind in the comfort of your home. Experience seamless connectivity in a tranquil setting.\n\nPositioned in the desirable East Roseville Parkway neighborhood, Stoneridge Apartments blends modern amenities with convenience. Each unit features stainless steel appliances, a dishwasher, and an in-unit washer/dryer, providing all the comforts of contemporary living. As a smoke-free community with easy walk-up access, we provide an ideal space for residents seeking a harmonious balance of technology and lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with High-Speed Internet Placer County",
      "seo_description": "Find high-speed internet apartments in Placer County at Stoneridge. Enjoy modern amenities and seamless connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-roseville-ca",
      "search_query": "one bedroom apartments roseville ca",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Roseville, CA",
      "h2_subtitle": "Explore spacious one-bedroom apartments at Stoneridge Apartments in vibrant Roseville, CA. Enjoy a variety of modern amenities tailored to your needs.",
      "page_copy": "Discover the perfect blend of comfort and style with the one-bedroom apartments at Stoneridge Apartments in Roseville, CA. Our carefully designed floor plans offer a spacious and inviting environment, ideal for individuals or couples looking to enjoy a serene living experience.\n\nNestled in the charming East Roseville Parkway area, Stoneridge Apartments provide all the modern conveniences you need. Each unit comes with stainless steel appliances, a dishwasher, and an in-unit washer/dryer, ensuring a seamless lifestyle. Embrace the smoke-free environment and convenient walk-up access, making it easy to feel at home in this tranquil community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Roseville, CA",
      "seo_description": "Find spacious one-bedroom apartments in Roseville, CA at Stoneridge. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-placer-county",
      "search_query": "two bedroom apartments placer county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Placer County",
      "h2_subtitle": "Spacious two-bedroom apartments await you at Stoneridge Apartments in Placer County. Enjoy premium amenities in a peaceful setting.",
      "page_copy": "If you're looking for spacious two-bedroom apartments in Placer County, Stoneridge Apartments offer the perfect blend of comfort and convenience. Each apartment is designed to accommodate a modern lifestyle, providing ample space and upscale features.\n\nSituated in the desirable East Roseville Parkway area, these apartments come with stainless steel appliances, a handy dishwasher, and in-unit washer/dryer for ultimate convenience. The smoke-free environment and walk-up access add to the tranquility of living here. At Stoneridge Apartments, you can enjoy the perfect balance of style and functionality in the heart of Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Placer County",
      "seo_description": "Discover spacious two-bedroom apartments at Stoneridge in Placer County. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166910",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-95661",
      "search_query": "three bedroom apartments 95661",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 95661",
      "h2_subtitle": "Explore spacious three-bedroom apartments at Stoneridge Apartments in the 95661 area. Enjoy modern amenities and a convenient location.",
      "page_copy": "Families and roommates will find the perfect home with the three-bedroom apartments at Stoneridge Apartments, located in the vibrant 95661 area of Roseville, CA. Offering ample space and contemporary design, these apartments are ideal for those seeking a blend of comfort and convenience.\n\nLocated near East Roseville Parkway, Stoneridge Apartments provide a wealth of amenities including stainless steel appliances, a dishwasher, and in-unit washer/dryer. Our smoke-free community with walk-up access ensures a relaxed and welcoming living environment. Enjoy modern living at Stoneridge Apartments in the heart of Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 95661",
      "seo_description": "Find spacious three-bedroom apartments in the 95661 area at Stoneridge. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5964"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372414780"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TX32792X"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "56463148338"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-603-7376 "
    }
  ],
  "custom_qb_id": "5964",
  "custom_repli_id": "18372414780",
  "custom_google_gtm_id": "GTM-TX32792X",
  "custom_hubspot_company_id": "56463148338",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-603-7376 "
};

export const generatedAt = '2026-09-23T19:54:41.370Z';
